/**
 * Budget Repository Factory
 *
 * 환경 변수(USE_MOCK_DATA)에 따라 Mock 또는 GoogleSheets Repository를 반환합니다.
 */

import { env } from '@/core/config/env'
import { logger } from '@/core/logger'
import { MockBudgetRepository } from './MockBudgetRepository'
import { GoogleSheetsBudgetRepository } from './GoogleSheetsBudgetRepository'
import type { BudgetRepository } from './BudgetRepository'

/**
 * Budget Repository 인스턴스 생성
 *
 * env.USE_MOCK_DATA 값에 따라 자동으로 선택됩니다.
 * - true: MockBudgetRepository 사용
 * - false: GoogleSheetsBudgetRepository 사용
 *
 * @returns BudgetRepository 구현체
 */
export function createBudgetRepository(): BudgetRepository {
  if (env.USE_MOCK_DATA) {
    logger.info('🔧 Mock Budget Repository 사용')
    return new MockBudgetRepository()
  }

  logger.info('🔗 Google Sheets Budget Repository 사용')
  return new GoogleSheetsBudgetRepository()
}

/**
 * 전역 Budget Repository 인스턴스
 *
 * 애플리케이션 전체에서 동일한 인스턴스를 사용합니다.
 */
export const budgetRepository = createBudgetRepository()

// Re-export 타입
export type { BudgetRepository, BudgetFilter } from './BudgetRepository'
export type { Budget } from '../types/Budget'
